import Strings from "../../../resources/Strings";
import Icons from "../../../resources/icons/Icons";
import { isUserSubscribed } from "../../../utils/UsersUtils";
import classes from "./Details.module.css";

const Details = (props) => {
  const isUserSubscribedRes = props?.utronUser !== undefined ? isUserSubscribed(props?.utronUser) : undefined;

  return (
    <div>
      <div className={classes.personalDetails}>
        {props.phoneNumber && (
          <div className={classes.detailItem}>
            <img src={Icons.PHONE} />
            <span className={classes.detailText}>+{props.phoneNumber}</span>
          </div>
        )}
        {props.email && (
          <div className={classes.detailItem}>
            <img src={Icons.EMAIL} />
            <span className={classes.detailText}>{props.email}</span>
          </div>
        )}
        {props.utronUser?.userAdditionalData[0]?.kioskLoginName && (
          <div className={classes.detailItem}>
            <img src={Icons.GMT_HEADER} />
            <span className={classes.detailText}>{props.utronUser?.userAdditionalData[0]?.kioskLoginName}</span>
          </div>
        )}
        {props.utronUser?.userAdditionalData[0]?.notes && (
          <div className={[classes.detailItem, classes.noteBox].join(' ')}>
            <img className={classes.detailIcon} src={Icons.MESSAGING2} />
            <span className={classes.detailText}>{props.utronUser?.userAdditionalData[0]?.notes}</span>
          </div>
        )}
        {isUserSubscribedRes !== undefined && (
          <>
            {isUserSubscribedRes ?
              <div className={classes.detailItem}>
                <img src={Icons.V_MARK} />
                <span className={classes.detailText}>{Strings.MESSAGING_SUBSCRIBED}</span>
              </div>
              :
              <div className={classes.detailItem}>
                <img src={Icons.X_MARK} />
                <span className={classes.detailText}>{Strings.MESSAGING_UNSUBSCRIBED}</span>
              </div>
            }
          </>
        )}
      </div>
      {props.children}
    </div>
  );
};

export default Details;
